import axios from "axios";
import { store } from "../redux/store/store";  
import { logout } from "../redux/slices/userSlice";
import { loginSuccess } from "../redux/slices/userSlice";

const LABBASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: LABBASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().user.token; 
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-new-access-token"];
    if (newToken) {
      const state = store.getState();
      const user = state.user.user;

      // Update only the token in Redux
      store.dispatch(
        loginSuccess({
          user: user || {},
          token: newToken,
        })
      );
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 403) {
      console.error("Token refresh failed or invalid:");
      // Optional: handle forced logout if needed
      store.dispatch(logout());
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
